export default function applyCalFilters(){
    this.setEvents(this, {prefix: "calendar"}, (cb) => {
        // to avoid page reload
        });
}   
